import { IVoice, Providers, VoiceAccess, VoiceConfig } from '@d-id/types';
import { atom } from 'recoil';

export const DEFAULT_VOICE: IVoice = {
    id: 'en-US-JennyNeural',
    language: 'English (United States)',
    provider: Providers.Microsoft,
    name: 'Jenny',
    gender: 'female',
    locale: 'en-US',
    access: VoiceAccess.Public,
    styles: [
        'assistant',
        'chat',
        'customerservice',
        'newscast',
        'angry',
        'cheerful',
        'sad',
        'excited',
        'friendly',
        'terrified',
        'shouting',
        'unfriendly',
        'whispering',
        'hopeful',
    ],
};
export const DEFAULT_VOICE_AGENTS = {
    id: 'en-US-JennyNeural',
    language: 'English (United States)',
};

export const DEFAULT_MALE_VOICE = 'en-US-AndrewNeural';
export const DEFAULT_FEMALE_VOICE = 'en-US-EmmaNeural';

export const DEFAULT_VOICE_CONFIG: VoiceConfig = {
    rate: '1',
    volume: 1,
    style: '',
};

export const ALL_VOICES_ID = 'ALL_VOICES_ID';

export const languageToVoicesMap = atom<Record<string, IVoice[]>>({
    key: 'language-to-voices-map',
    default: {},
});
